import type { FaireProductEntity } from "../../entity_types/product";

export const p_k9u8p5rx75: FaireProductEntity = {
  token: "p_k9u8p5rx75",
  type: "product",
  name: "SECRET BOX_14K Gold Dipped Ceramic Evil Eye Hoop Earrings",
  brandToken: "b_c3xmn96nkh",
  brandName: "Sensibling Corp.",
  imageUrl:
    "https://cdn.faire.com/fastly/df6df06415ca9702de5013a6165862fa5b9ac04e7364afa3da0cede1b04474a3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ea4c981e463b8596bfd502576a1788ea48abbfef586f85a53376b3205d46104c.jpeg",
    "https://cdn.faire.com/fastly/1cab50df248db51029b7774d58fc2b235756e0f95bce5be7fe1ebe7c7942bce3.jpeg",
    "https://cdn.faire.com/fastly/17f190ecc190caa9cc01c0631a5157df96ddafb535a96c59a07eed4cdf074d05.jpeg",
  ],
  priceDollars: 11.06,
  description:
    '• Size : 0.75" X 1.2"\n• Pin Catch\n• Trendy heart dangle earrings featuring an evil eye charm and decorative accents. A unique statement piece combining playful and protective symbolism, perfect for everyday wear or gifting. Add a touch of modern edge and meaning to your jewelry collection.\n• Gold Dipped',
  tags: [],
  msrpDollars: 22.12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:45.734Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
